import Hero from './components/Hero';
import Services from './components/Services';
// import styled from 'styled-components';
import './styles.scss';

function App() {
  return (
    <>
    <Hero/>
    <Services/>
    </>
  );
}

export default App;
